import React from 'react'
import ReactModal from 'react-modal'
import * as portals from 'react-reverse-portal'

import Steps from './steps'

const MultiStep = () => {
  const [isModalOpened, toggleModal] = React.useState(false)
  const portalNode = React.useMemo(() => portals.createHtmlPortalNode(), [])
  return (
    <>
      <portals.InPortal node={portalNode}>
        <Steps
          onOpen={toggleModal.bind(null, true)}
          onClose={toggleModal.bind(null, false)}
        />
      </portals.InPortal>

      {!isModalOpened && (
        <div className='not-modal'>
          <portals.OutPortal node={portalNode} />
        </div>
      )}

      <ReactModal
        isOpen={isModalOpened}
        onRequestClose={toggleModal.bind(null, false)}
        className='ReactModal__Content ReactModal__Content--form-popup'
      >
        <div className='app'>
          <portals.OutPortal node={portalNode} />
        </div>
      </ReactModal>
    </>
  )
}

export default MultiStep
